import { createFileRoute, Outlet, useMatchRoute } from "@tanstack/react-router";

import { useUser } from "@/web/auth/useUser";
import { Redirect } from "@/web/components/Redirect";

export const Route = createFileRoute("/_protected/profile")({
  component: ProfileLayout,
});

function ProfileLayout() {
  const user = useUser();
  const matchRoute = useMatchRoute();
  if (!user) {
    return null;
  }
  // `/profile/user` is account settings (contact info + avatar) and is
  // meaningful for any signed-in user — including one who picked the investor
  // path but hasn't finished onboarding yet (no brand/investor ids). The
  // dashboard sub-routes (smb/inv/index) still require a completed profile, so
  // only the user sub-route is exempt from the "send them back to onboarding"
  // redirect.
  const isUserSettingsRoute = Boolean(matchRoute({ to: "/profile/user" }));
  const hasAnyProfile = user.brandIds.length > 0 || user.investorIds.length > 0;
  if (!hasAnyProfile && !isUserSettingsRoute) {
    return <Redirect to="/onboarding" replace />;
  }
  return <Outlet />;
}
